import React from 'react'
import LogoSvg from '../assets/wingbeat-logo.svg?react'

/**
 * The official Wingbeat club badge (WINGBEAT / hills + paraglider / PARAGLIDING /
 * Ettrick & Yarrow Valleys / Since 1991), imported as a React component via
 * vite-plugin-svgr so it inherits `currentColor` and can be themed with CSS.
 *
 * The badge already contains the "WINGBEAT" wordmark, so it is used on its own
 * (no adjacent text). Control size with the `height` prop or CSS on the wrapper.
 */
function WingbeatLogo({ height = 44, title = 'Wingbeat Paragliding Club', className = '' }) {
  return (
    <LogoSvg
      className={`wingbeat-logo ${className}`.trim()}
      role="img"
      aria-label={title}
      style={{ height, width: 'auto', display: 'block' }}
    />
  )
}

export default WingbeatLogo
